import React, { Component } from "react";

class ZoneStatusLogRow extends Component {

  renderInActRow(zone) {
	  return(
      <tr>
        <td>{zone.name}</td>
        <td>
		<span className="badge badge-secondary ml-2">Not Active</span>
        </td>
        <td></td>
        <td>
        </td>
        <td>
        </td>
      </tr>
	  )
  }
  renderRow(golf, slot, i){
	  let statusBadgeZone;
	  let now = new Date();
	  
	  for (var j = 0; j < golf.slots.length; j++) {
	        let start_slot = new Date(now.getFullYear(), now.getMonth(), now.getDate(), golf.slots[j].sh, golf.slots[j].sm);
	        let end_slot = new Date(now.getFullYear(), now.getMonth(), now.getDate(), golf.slots[j].eh, golf.slots[j].em);

		    if (now > start_slot && now < end_slot) {
	          if (golf.slots[j].tp === 0) {
	            statusBadgeZone = (
					<span className="badge badge-success">Active</span>
	            );
	            break;
	          }
	          else {
	            statusBadgeZone = (
					<span className="badge badge-warning">TMZ Only</span>
	            );
	          break;
			 }
	        }
	        else 
	          statusBadgeZone = (
	            <span className="badge badge-secondary ml-2">Not Active</span>
	          );	

	  }
	  if(i===0)
	  return(
		<tr>
		  <td>{golf.name}</td>
		  <td>
		  {statusBadgeZone}
		  </td>
		  <td>{slot.FL}</td>
		  <td>{slot.sh === 0? "00":slot.sh}:{slot.sm === 0? "00":slot.sm}
		  </td>
		  <td>{slot.eh === 0? "00":slot.eh}:{slot.em === 0? "00":slot.em}
		  </td>
		</tr>
		);
		else 
		return(
			<tr>
			  <td></td>
			  <td>
			  </td>
			  <td>{slot.FL}</td>
			  <td>{slot.sh === 0? "00":slot.sh}:{slot.sm === 0? "00":slot.sm}
			  </td>
			  <td>{slot.eh === 0? "00":slot.eh}:{slot.em === 0? "00":slot.em}
			  </td>
			</tr>
			);
  }
  render() {


	if(this.props.zone == null)
		return null;

    if (this.props.zone.slots && this.props.zone.slots.length === 0)
      //return this.renderInActRow(this.props.zone);
      // Don't show inactive zones on the homepage
	  return ""
	console.log(this.props.zone)
    return (
         this.props.zone.slots.map((slot, i) => {
           return this.renderRow(this.props.zone, slot, i);
         })
       );
	
	   }
}

export default ZoneStatusLogRow;
